
import Vue from "vue";

const END_POINT = "/studentMedicalAlert";

const fetchStudentMedicalAlerts = async (studentId) => {
  return Vue.axios(END_POINT + '/by-student/' + studentId)
    .then((response) => {
      return response.data;
    });
}

const fetchStudentsMedicalAlerts = async (studentIds) => {
  const ids =
    studentIds && studentIds.length > 0 ? studentIds.join(",") : null;
  if (ids) {
    return Vue.axios(END_POINT + '/by-students', { params: { studentIds: ids } }).then((response) => {
      const medicalAlerts = response.data;
      return medicalAlerts;
    })
  }
}

const groupMedicalAlertsByStudents = (medicalAlerts) => {

  if(medicalAlerts && medicalAlerts.length > 0){
    return medicalAlerts.reduce( (groups, alert) => {
      if(groups[alert.studentId]){
        groups[alert.studentId].medicalAlerts.push(alert);
      }
      else{ 
        groups[alert.studentId] = {
          studentName: alert.studentName,
          medicalAlerts: [alert],
        }
      }
      return groups;
    }, {})
  }
  else{ return {} }
}

export {
  fetchStudentsMedicalAlerts,
  fetchStudentMedicalAlerts,
  groupMedicalAlertsByStudents
};
